import React, { Suspense } from "react";

import "img/icons.svg";

import ModalContainer from "common/Modals";
import ToastContainer from "common/Toast";
import PortalAnnouncements from "portal/Announcements";
import ErrorContainer from "apps/components/ErrorContainer";

class AppContainer extends ErrorContainer {
    renderContainer() {
        return (
            <div className="app-container">
                <Suspense fallback={<p>Loading...</p>}>{this.props.children}</Suspense>
                <ModalContainer />
                <ToastContainer />
                <PortalAnnouncements />
            </div>
        );
    }
}

export default AppContainer;
